<template>
  <div class="imgBgSSO">
    <div class="logo"><img src="@/assets/haleon-log.png" width="250"></div>
    <div class="loginSSo">
      <div class="content">
        <div class="warn-img"><img src="@/assets/Vector.png" width="80"></div>
        <h1>该CEDL Portal登录地址已停用<div style="padding-top:10px">5秒后自动跳转</div>
        </h1>
        <p>
          请点击以下链接进入新的CEDL Service Portal。
        </p>
        <P><a :href="returnUrl">{{returnUrl}}</a></P>
        <div class="btn-close" @click="close()">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginHome',
  data () { // 所有的数据都写在里面
    return {
      returnUrl: this.$baseUrlConfig.returnUrl
    }
  },
  created () {
  },
  mounted () {
    setTimeout(() => {
      window.location.href = this.returnUrl
    }, 5000)
  },
  methods: {// 所有的方法写在里面
    close () {
      console.log('test')
      window.open('about:blank', '_self').close()
    }
  }
}
</script>

<style scoped>
.imgBgSSO {
  background: url(../../../assets/tips-bg.png) no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
  text-align: center;
}

.logo {
  position: absolute;
  right: 50px;
  top: 50px;
}
.loginSSo {
  height: 360px;
  position: absolute;
  width: 100%;
  text-align: center;
  top: 45%;
  margin-top: -190px;
}
.content {
  text-align: center;
}
.warn-img {
  margin-bottom: 50px;
}
h1 {
  font-size: 24px;
}
h1,
p {
  margin-bottom: 20px;
}
p {
  font-size: 20px;
}
a {
  color: #59d9a3;
  text-decoration: underline;
}
.btn-close {
  width: 206px;
  height: 57px;
  background: #dbfff7;
  box-shadow: inset 0px 0px 0px 7px #ffffff;
  border-radius: 30px 30px 30px 30px;
  border: 3px solid #000000;
  color: #000;
  font-size: 24px;
  line-height: 57px;
  vertical-align: middle;
  margin: 30px auto;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/loginHome.vue